export default class ValueBoolean {
    public value: boolean = false;
}